import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

axios.defaults.headers.post['Content-Type'] = 'application/json';

// Acción para obtener los datos meteorológicos de un nodo
export const meteorologicoNodo = createAsyncThunk(
    'meteorologicoNodo/getMeteorologicoNodo',
    async ({ lat, lon }) => {
        try {
            const response = await axios.get("/api/sensor/getMeteorologicoNodo", {
                params: {
                    lat,
                    lon
                }
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    }
);